import { render, staticRenderFns } from "./importImage.vue?vue&type=template&id=33766ed7&"
import script from "./importImage.vue?vue&type=script&lang=js&"
export * from "./importImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports